import { Search, X } from "lucide-react";

const SearchBar = ({ query, onChange, onClear }) => {
  return (
    <>
      <style>{`
        @keyframes search-glow {
          0%, 100% { box-shadow: 0 0 0 0 transparent; }
          50% { box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.25), 0 0 20px rgba(59, 130, 246, 0.15); }
        }
        .search-input:focus {
          animation: search-glow 2s ease-in-out infinite;
          border-color: rgba(139, 92, 246, 0.5) !important;
          background: rgba(255,255,255,0.07) !important;
        }
      `}</style>
      <div className="relative flex items-center w-full">
        <Search className="absolute left-4 w-4 h-4 text-white/30 pointer-events-none" />
        <input
          type="text"
          value={query}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search posts, users, captions..."
          className="search-input w-full bg-white/5 border border-white/10 rounded-2xl
            pl-11 pr-10 py-3 text-white text-sm outline-none
            placeholder-white/30 transition-all duration-300"
        />
        {query && (
          <button
            onClick={onClear}
            className="absolute right-4 text-white/30 hover:text-white/60 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </>
  );
};

export default SearchBar;
